import { render, staticRenderFns } from "./huiyuan.vue?vue&type=template&id=798c5d54&scoped=true"
import script from "./huiyuan.vue?vue&type=script&lang=js"
export * from "./huiyuan.vue?vue&type=script&lang=js"
import style0 from "./huiyuan.vue?vue&type=style&index=0&id=798c5d54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798c5d54",
  null
  
)

export default component.exports